import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import api from "../services/api";
import "../styles/directorio.css";

const API_BASE = process.env.REACT_APP_API_URL || "http://localhost:8000/api";
const BACKEND_ORIGIN = API_BASE.replace(/\/api\/?$/, "");

const resolveAvatarUrl = (avatar) => {
  if (!avatar) return "";
  if (/^https?:\/\//i.test(avatar)) return avatar;
  if (avatar.startsWith("/")) return `${BACKEND_ORIGIN}${avatar}`;
  return `${BACKEND_ORIGIN}/${avatar}`;
};

export default function Directorio() {
  const [miembros, setMiembros] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    const fetchDirectorio = async () => {
      setLoading(true);
      try {
        const { data } = await api.get("/directorio/");
        const mappedMiembros = (Array.isArray(data) ? data : [])
          .filter((item) => item?.socio_nombre)
          .map((item, index) => ({
            id: item?.id || `${item?.cargo || "cargo"}-${index}`,
            nombre: item?.socio_nombre,
            cargo: item?.cargo || "",
            img: resolveAvatarUrl(item?.socio_avatar),
          }));

        setMiembros(mappedMiembros);
      } catch (error) {
        setMiembros([]);
      } finally {
        setLoading(false);
      }
    };

    fetchDirectorio();
  }, []);

  useEffect(() => {
    if (selectedIndex !== null && selectedIndex >= miembros.length) {
      setSelectedIndex(null);
    }
  }, [selectedIndex, miembros.length]);

  const openModal = (index) => setSelectedIndex(index);
  const closeModal = () => setSelectedIndex(null);

  const nextMember = () => setSelectedIndex((prev) => (prev + 1) % miembros.length);
  const prevMember = () =>
    setSelectedIndex((prev) => (prev - 1 + miembros.length) % miembros.length);

  if (loading) {
    return (
      <div className="directorio-container">
        <Box className="directorio-loading">
          <CircularProgress />
        </Box>
      </div>
    );
  }

  return (
    <div className="directorio-container">
      <h1 className="directorio-titulo">DIRECTORIO</h1>
      <h3 className="directorio-subtitulo">
        ASOCIACIÓN BOLIVIANA DE INGENIERÍA SANITARIA Y AMBIENTAL - LA PAZ
      </h3>

      {miembros.length === 0 ? (
        <p className="directorio-empty">El directorio está siendo actualizado</p>
      ) : (
        <div className="directorio-grid">
          {miembros.map((m, index) => (
            <div key={m.id} className="directorio-card" onClick={() => openModal(index)}>
              <img src={m.img} alt={m.nombre} className="directorio-img" />
              <h4>{m.nombre}</h4>
              <p>{m.cargo}</p>
            </div>
          ))}
        </div>
      )}

      {selectedIndex !== null && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={closeModal}>
              ✕
            </button>
            <button className="modal-arrow left" onClick={prevMember}>
              ‹
            </button>
            <img
              src={miembros[selectedIndex].img}
              alt={miembros[selectedIndex].nombre}
              className="modal-img"
            />
            <h2>{miembros[selectedIndex].nombre}</h2>
            <h4>{miembros[selectedIndex].cargo}</h4>
            <button className="modal-arrow right" onClick={nextMember}>
              ›
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
